import { maska } from 'maska';

export default {
	name: 'mask',
	directive: maska
};
